import { User } from '../../user/objects/user';
import { Preferences } from '../objects/preferences';
import { Permission } from '../../permissions/objects/permission';

export const SET_LOGIN = 'PROFILE_SET_LOGIN';
export const SET_PERMISSIONS = 'PROFILE_SET_PERMISSIONS';
export const SET_PREFERENCES = 'PROFILE_SET_PREFERENCES';
export const SET_PROFILE = 'PROFILE_SET_PROFILE';
export const SET_TOKEN_EXPIRES_AT = 'PROFILE_SET_TOKEN_EXPIRES_AT';

interface SetLoginAction {
    type: typeof SET_LOGIN,
    payload: {
        permissions: Permission[],
        token: string,
        user: User,
        token_expires_at: string
    }
}

interface SetPermissionsAction {
    type: typeof SET_PERMISSIONS,
    payload: null | Permission[]
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetProfileAction {
    type: typeof SET_PROFILE,
    payload: null | User
}

interface SetTokenExpiresAtAction {
    type: typeof SET_TOKEN_EXPIRES_AT,
    payload: string | null
}

export type ProfileActionTypes = SetLoginAction | SetPermissionsAction | SetPreferencesAction | SetProfileAction | SetTokenExpiresAtAction;